export default "query GetCommandFile($fileId: ID!) {\n  getCommandFile(fileId: $fileId) {\n    id\n    path\n  }\n}\n"